import API from "../axios";

const deleteTelegram = async (accessToken, uuid) => {
    try {
        const response = await API.delete(`/telegram/delete/${uuid}`, {
            headers: {
                Authorization: `Bearer ${accessToken.replace('Bearer ', '')}`
            }
        });
        return response.data;
    } catch (error) {
        if (error.response) {
            return error.response.data;
        }
        return {
            success: false,
            message: 'Lỗi kết nối mạng'
        }
    }
}

export default deleteTelegram; 
